import { render, staticRenderFns } from "./NewFeatureDialog.vue?vue&type=template&id=72df661c&scoped=true"
import script from "./NewFeatureDialog.vue?vue&type=script&lang=js"
export * from "./NewFeatureDialog.vue?vue&type=script&lang=js"
import style0 from "./NewFeatureDialog.vue?vue&type=style&index=0&id=72df661c&prod&lang=scss&scoped=true"
import style1 from "./NewFeatureDialog.vue?vue&type=style&index=1&id=72df661c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df661c",
  null
  
)

export default component.exports